import api from 'utils/api';

const distributorIdMap = {};

export const getDistributors = async (userRole) => {
  let results = [];
  let hasError;
  let page = 0;
  const role = 'DISTRIBUTOR';
  const { response, error } = await api.getMembers({ page, role });
  const totalPages = response?.totalPages;
  results = results.concat(response?.content || []);
  while (!error && !hasError && totalPages && page < totalPages - 1) {
    page++;
    const result = await api.getMembers({ page, role });
    if (result.error) hasError = true;
    results = results.concat(result?.response?.content || []);
  }

  results.forEach((el) => {
    distributorIdMap[el.organizationId] = true;
  });
};

export const isRentalUser = (el, parentOrg, userRole) => {
  if (
    el.role === 'HOME_USER' &&
    !!el.organizationId &&
    ((userRole !== 'group_manager' && Number(el.organizationId) !== 1 && !distributorIdMap[el.organizationId]) ||
      (userRole === 'group_manager' &&
        Number(el.organizationId) !== 1 &&
        Number(el.organizationId) !== Number(parentOrg?.id)))
  ) {
    return true;
  }
  return false;
};
